/**
 * Represents variable data for a figure property, pairing a variable name with its current value.
 */
export interface FigureVarDataDto {
  varName: string;
  value: string;
}

/**
 * Type guard to check if an object is a FigureVarDataDto value.
 *
 * @param obj - The object to check.
 * @returns True when the value contains a variable name and string value.
 */
export const isFigureVarDataDto = (obj: unknown): obj is FigureVarDataDto => {
  if (typeof obj !== "object" || obj === null) {
    return false;
  }
  const chkObj = obj as FigureVarDataDto;
  if (typeof chkObj.varName !== "string") {
    return false;
  }
  if (typeof chkObj.value !== "string") {
    return false;
  }
  return true;
};
